import { $$ } from '../lib/dom.js';

/* Vitrina de "Resultados concretos": patrón tablist / tab / tabpanel de WAI-ARIA.
   El marcado viene con los seis paneles visibles, así que sin JS la sección sigue
   mostrando todo, apilado. Es este módulo el que los oculta y arma las pestañas. */
export function initTabs() {
  $$('[data-tabs]').forEach((root) => {
    const tabs = $$('[role="tab"]', root);
    const panels = tabs
      .map((tab) => document.getElementById(tab.getAttribute('aria-controls')))
      .filter(Boolean);
    if (tabs.length < 2 || panels.length !== tabs.length) return;

    function select(i, { moverFoco = false } = {}) {
      tabs.forEach((tab, j) => {
        const activa = j === i;
        tab.setAttribute('aria-selected', activa ? 'true' : 'false');
        // Roving tabindex: del tablist se entra con Tab y se recorre con flechas.
        tab.tabIndex = activa ? 0 : -1;
        panels[j].hidden = !activa;
      });
      if (moverFoco) tabs[i].focus();
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i));
    });

    root.addEventListener('keydown', (e) => {
      const actual = tabs.indexOf(document.activeElement);
      if (actual === -1) return;
      // La lista es vertical en escritorio y horizontal en teléfono: se aceptan las cuatro.
      const salto = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (salto) {
        e.preventDefault();
        select((actual + salto + tabs.length) % tabs.length, { moverFoco: true });
      } else if (e.key === 'Home') {
        e.preventDefault();
        select(0, { moverFoco: true });
      } else if (e.key === 'End') {
        e.preventDefault();
        select(tabs.length - 1, { moverFoco: true });
      }
    });

    // Un enlace a #caso-N (o el modal, que usa los mismos ids) abre esa pieza.
    function abrirDesdeHash() {
      const i = panels.findIndex((panel) => '#' + panel.id === window.location.hash);
      if (i >= 0) select(i);
    }
    window.addEventListener('hashchange', abrirDesdeHash);

    select(0);
    abrirDesdeHash();
  });
}
